import { ca } from '@cian/analytics';

import { EMessageFileTypes } from '../../types/messageFiles';

const TRACK_FILE_LABEL = {
  [EMessageFileTypes.Image]: 'Photo',
  [EMessageFileTypes.ImageAsDocument]: 'Document',
  [EMessageFileTypes.Document]: 'Document',
};

export function trackAttachFileButtonClick(chatId: string, opponentId?: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'Attachment',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
      },
    },
  });
}

export function trackInputTypeClick(fileType: EMessageFileTypes | null, chatId: string, opponentId?: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: TRACK_FILE_LABEL[fileType || EMessageFileTypes.Document],
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
      },
    },
  });
}

export function trackOnOfferSendButtonClick(chatId: string, opponentId?: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'Offer',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
      },
    },
  });
}

type TTrackFileSend = {
  fileType: EMessageFileTypes;
  chatId: string;
  status: 'success' | 'failure';
  fileId?: string;
  opponentId?: number;
};

export function trackFileSend({ fileType, chatId, status, fileId, opponentId }: TTrackFileSend) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Send_sopr',
    label: TRACK_FILE_LABEL[fileType],
    page: {
      extra: {
        status,
        chat_id: chatId,
        file_id: fileId,
        opponent_id: opponentId,
      },
    },
  });
}
